import React from 'react';
import Footer from './footer.js';

const services = [
    {
        number: "01",
        title: "Diseño y Motion Graphics",
        description: "Creamos piezas gráficas y animaciones que transforman ideas, conceptos e identidades de marca en contenido visual dinámico.",
        examples: [
            "Animación de logotipos e identidades visuales.",
            "Motion graphics para publicidad y redes sociales.",
            "Infografías y visualización de datos animados.",
            "Animaciones tipográficas y gráficas explicativas.",
            "Paquetes gráficos para marcas y campañas.",
            "Animaciones 2D y 3D."
        ]
    },
    {
        number: "02",
        title: "Producción Audiovisual",
        description: "Producimos contenido audiovisual para comunicar ideas, contar historias y conectar marcas con sus audiencias.",
        examples: [
            "Videos corporativos e institucionales.",
            "Videos publicitarios y promocionales.",
            "Entrevistas y testimoniales.",
            "Videos de productos y servicios.",
            "Cobertura audiovisual de eventos.",
            "Videos educativos e informativos."
        ]
    },
    {
        number: "03",
        title: "Postproducción y Efectos Visuales",
        description: "Integramos edición, composición y efectos visuales para dar forma, ritmo y acabado profesional a cada producción.",
        examples: [
            "Edición y montaje de video.",
            "Corrección de color y acabado visual.",
            "Composición digital y chroma key.",
            "Integración de elementos 2D y 3D en video.",
            "Limpieza y reemplazo de elementos en escena.",
            "Efectos visuales para publicidad y contenido audiovisual."
        ]
    },
    {
        number: "04",
        title: "Visuales para Eventos, Pantallas LED y Videomapping",
        description: "Diseñamos y producimos contenido visual para escenarios, eventos y superficies inmersivas, adaptándolo a las características técnicas y creativas de cada espacio.",
        examples: [
            "Visuales para conciertos y espectáculos.",
            "Contenido para pantallas LED en eventos corporativos.",
            "Animaciones y loops visuales para escenarios.",
            "Videomapping sobre fachadas, edificios y estructuras.",
            "Proyecciones sobre productos, objetos y superficies especiales.",
            "Contenido para pantallas panorámicas, formatos especiales y configuraciones multipantalla.",
            "Visuales sincronizados con música, presentaciones o momentos del evento."
        ]
    },
    {
        number: "05",
        title: "IA Aplicada a la Producción Creativa",
        description: "Integramos herramientas de inteligencia artificial en los procesos creativos y audiovisuales para explorar nuevas posibilidades visuales y optimizar la producción.",
        examples: [
            "Generación de imágenes y recursos visuales con IA.",
            "Creación y transformación de video mediante IA.",
            "Voces sintéticas y narraciones automatizadas.",
            "Desarrollo de conceptos visuales y exploración de estilos.",
            "Adaptación de recursos creativos para diferentes campañas.",
            "Integración de herramientas de IA en flujos de trabajo audiovisuales."
        ]
    },
    {
        number: "06",
        title: "Automatización de Contenido",
        description: "Diseñamos sistemas que conectan datos, plantillas y herramientas de producción para generar contenido de manera repetible, personalizada y escalable.",
        examples: [
            "Generación masiva de videos personalizados a partir de Excel o bases de datos.",
            "Producción automatizada de imágenes y piezas gráficas.",
            "Catálogos, folletos y materiales promocionales generados desde datos.",
            "Adaptación automática de contenido a diferentes formatos y plataformas.",
            "Generación de versiones personalizadas para clientes, empleados o estudiantes.",
            "Flujos de trabajo que automatizan la preparación, renderización y exportación de contenido."
        ]
    },
    {
        number: "07",
        title: "Software a la Medida y Tecnología",
        description: "Diseñamos y desarrollamos soluciones tecnológicas para resolver necesidades específicas, optimizar procesos y ampliar las posibilidades de la producción audiovisual y digital.",
        examples: [
            "Desarrollo de aplicaciones web y de escritorio.",
            "Sistemas internos para administrar información y procesos.",
            "Herramientas para controlar y reproducir contenido audiovisual en pantallas.",
            "Software para gestionar visuales en eventos e instalaciones.",
            "Integración de inteligencia artificial, APIs y servicios externos.",
            "Plataformas educativas, contenido e-learning, experiencias interactivas y soluciones SCORM.",
            "Herramientas personalizadas para automatizar tareas y conectar sistemas."
        ]
    }
];

const Services = () => {

    return (
        <div className="services_page">

            <div className="services_header">
                <h1 className="section_titles">Servicios Render Playz</h1>
            </div>

            <div className="services_grid">
                {services.map(service => (
                    <section className="service_card" key={service.number}>
                        <span className="service_num">{service.number}</span>
                        <h2 className="service_title">{service.title}</h2>
                        <p className="service_desc">{service.description}</p>
                        <p className="service_examples_title">Ejemplos de proyectos:</p>
                        <ul className="service_examples">
                            {service.examples.map((example, index) => (
                                <li key={index}>{example}</li>
                            ))}
                        </ul>
                    </section>
                ))}
            </div>

            <Footer/>
        </div>
    );

}

export default Services;
